import { useMutation, useQueryClient } from '@tanstack/react-query';
import { saveCoursePreference } from '../../core/coursePreferences.js';

export const useSaveCoursePreference = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ courseId, preferenceName, enabled }) =>
      saveCoursePreference(courseId, preferenceName, enabled),
    onSuccess: (_, { courseId, preferenceName }) => {
      queryClient.invalidateQueries([
        'coursePreference',
        preferenceName,
        courseId,
      ]);
    },
  });
};
